import type { AllRouteEndpoints } from "../routeTypes";
export const engagementLandingPagesAppGroupIdCustomSubdomainReactivateCacheKeys: AllRouteEndpoints[] = [
  "/engagement/landing_pages/:app_group_id/custom_subdomain",
];
